<app-map
  [width]="'100%'"
  [height]="'100vh'"
  [links]="links"
  [geojsonFeatures]="geojsonFeatures"
  [highlight]="highlight"
  (mapMove)="mapMove($event)"
></app-map>
